import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const alertVariants = cva(
  "relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive:
          "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Alert = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(alertVariants({ variant }), className)}
    {...props} />
))
Alert.displayName = "Alert"

/* Il titolo dell'avviso e' un'INTESTAZIONE: chi naviga a voce ci salta sopra.
   Un'intestazione senza contenuto e' un vicolo cieco — si sente "intestazione,
   livello 5" e poi il nulla. Prima i figli arrivavano dentro `{...props}` e
   l'h5 veniva emesso comunque, anche vuoto; ora si rende solo se c'e' davvero
   qualcosa da leggere. (E' anche il warning jsx-a11y/heading-has-content: la
   regola non vede attraverso lo spread, e aveva ragione a non fidarsi.)

   `as` esiste perche' un componente NON PUO' SAPERE a che profondita' lo
   montano, e un livello sbagliato rompe la scaletta per chi naviga a voce: su
   /design?s=errori l'h5 fisso faceva H1 → H5 → H2, cioe' un sottolivello che
   non esiste. Il valore giusto lo sa solo chi lo usa, quindi lo passa lui.
   Il default resta `h5`: chi non lo passa si comporta come prima. */
const AlertTitle = React.forwardRef(({ className, children, as: Tag = "h5", ...props }, ref) => {
  if (children === null || children === undefined || children === false || children === "") return null;
  return (
    <Tag
      ref={ref}
      className={cn("mb-1 font-medium leading-none tracking-tight", className)}
      {...props}>
      {children}
    </Tag>
  );
})
AlertTitle.displayName = "AlertTitle"

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm [&_p]:leading-relaxed", className)}
    {...props} />
))
AlertDescription.displayName = "AlertDescription"

export { Alert, AlertTitle, AlertDescription }
